export function getPlatformTypeByUrl(url: string): "uwants" | "nearD" {
  const { hostname } = new URL(url);
  const type = hostname.includes("uwants") ? "uwants" : "nearD";
  return type;
}
